<template>
  <div class="ln-modal" :class="{ cross: iscross }">
    <Dialog v-model="show" :show-confirm-button="false" :overlayStyle="{ 'background-color': 'rgba(0, 0, 0, 0.4)' }">
      <div class="modal-title" v-show="title">
        <div v-if="componentName == 'Login' ||  componentName == 'PhoneLogin' " style="display: flex;justify-content: space-around">
          <span v-for="(item,index) in loginName" :class="{active: index==currIndex}" :key="index" @click="switchLogin(item.id, index)">{{item.name}}</span>
          <!-- <span style="position: absolute;color: #ddd">|</span> -->
        </div>
        <div v-else>{{ title }}</div>
        <!-- <div v-if="!isForceCert" class="close-icon-wrap" @click="close">
          <Icon class="close-icon" name="cross" />
        </div> -->
      </div>

      <div class="modal-wrap">
        <keep-alive>
          <component
          :is="currentComponentName"
          @hook:mounted="componentMounted"
          @change-component="changeComponent"
          @close="close"
        ></component>
        </keep-alive>
        
      </div>
    </Dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Dialog, Icon } from 'vant';
import Login from '@/components/Login';
import PhoneRegister from '@/components/PhoneRegister';
import PhoneLogin from '@/components/PhoneLogin';
import ForgetPassword from '@/components/ForgetPassword';
import UserAccount from '@/components/UserAccount';
import BindPhone from '@/components/BindPhone';
import Certification from '@/components/Certification';
import CertFront from '@/components/CertFront';
import GameState from '@/components/GameState';
import Health from '@/components/Health';
import SavePassword from '@/components/SavePassword';
import PreRebate from '@/components/PreRebate';
import AccountRegist from '@/components/AccountRegist.vue';

export default {
  name: 'modal',
  components: {
    Dialog: Dialog.Component,
    Icon,
    Login,
    PhoneRegister,
    PhoneLogin,
    ForgetPassword,
    UserAccount,
    BindPhone,
    Certification,
    CertFront,
    GameState,
    Health,
    SavePassword,
    PreRebate,
    AccountRegist
  },
  data() {
    return {
      show: false,
      currentComponentName: 'PhoneLogin',
      title: '账号登录',
      // 保存当前组件实例，暂时没用到
      currentComponent: null,
      compontname: '',
      titleMap: {
        Login: '账号登录',
        PhoneRegister: '手机注册',
        PhoneLogin: '手机登录',
        ForgetPassword: '忘记密码',
        UserAccount: '用户账号',
        BindPhone: '绑定手机',
        Certification: '实名认证',
        Guest: '快速注册',
        CertFront: '',
        GameState: '',
        iscross: false,
        SavePassword: '快速注册',
        AccountRegist: '账号注册'
      },
      loginName: [{id: 'PhoneLogin', name: '手机登录'}, {id: 'Login', name: '账号登录'}],
      currIndex: 0
    };
  },
  computed: {
    ...mapState(['isShow', 'componentName', 'componentParams', 'changeCompName']),
    ...mapGetters(['isForceCert'])
  },

  watch: {
    isShow(val) {
      this.show = val;
    },
    componentName(val) {
      this.currentComponentName = val;
      if (val == 'Login') {
        this.currIndex = 1
      } else {
        this.currIndex = 0;
      }
    },
    currentComponentName(val) {
      this.title = this.titleMap[val] || '';
    },
    changeCompName(val) {
      this.title = val;
    }
  },
  created() {
    // console.log(this.componentName)
    if (window.innerWidth > window.innerHeight) {
      this.iscross = true;
    } else {
      this.iscross = false;
    }
  },
  mounted() {},
  methods: {
    close() {
      this.$store.commit('CLOSE');
    },
    // 动态组件加载完成时
    componentMounted(component) {
      this.currentComponent = component;
    },
    // 切换动态组件
    changeComponent(nextComponentName) {
      this.$store.commit('SHOW', nextComponentName);
    },
    switchLogin(id, index) {
      this.$store.commit('SHOW', id);
      this.currIndex = index;
    }
  }
};
</script>
<style lang="scss">
.modal-title {
  text-align: center;
  padding: 15px;
  .close-icon-wrap {
    position: absolute;
    right: 6px;
    top: 10px;
    width: 30px;
    height: 30px;
    .close-icon {
      vertical-align: middle;
    }
  }
  .active {
    font-weight: bold;
  }
}

.modal-wrap {
  margin: 0 auto;
  background: white;
  border-radius: 5px;
  overflow: hidden;
  // width: 80vw;
  padding: 0 0 10px 0;
  .bottom {
    margin: 16px;
    .login-row {
      + .login-row {
        margin-top: 10px;
      }
    }
    .link-wrap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
